import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 p-4 pb-0 mb-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-6 col-xxl-3" }
const _hoisted_5 = { class: "col-sm-6 col-xxl-3" }
const _hoisted_6 = { class: "col-sm-6 col-xxl-3" }
const _hoisted_7 = { class: "col-sm-6 col-xxl-3" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-8" }
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = { class: "row justify-content-center" }
const _hoisted_12 = { class: "col-xl-4 col-xxl-4 col-lg-5" }
const _hoisted_13 = { class: "col-xl-8 col-xxl-8 col-lg-7" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-4" }
const _hoisted_16 = { class: "col-lg-4" }
const _hoisted_17 = { class: "col-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WelcomeBack = _resolveComponent("WelcomeBack")!
  const _component_TotalSalesChart = _resolveComponent("TotalSalesChart")!
  const _component_TotalOrdersChart = _resolveComponent("TotalOrdersChart")!
  const _component_TotalProfitChart = _resolveComponent("TotalProfitChart")!
  const _component_TotalRevenueChart = _resolveComponent("TotalRevenueChart")!
  const _component_RecentEarningsChart = _resolveComponent("RecentEarningsChart")!
  const _component_SalesByLocations = _resolveComponent("SalesByLocations")!
  const _component_TransactionHistory = _resolveComponent("TransactionHistory")!
  const _component_RecentOrders = _resolveComponent("RecentOrders")!
  const _component_RealTimeSalesChart = _resolveComponent("RealTimeSalesChart")!
  const _component_SalesOverviewChart = _resolveComponent("SalesOverviewChart")!
  const _component_GrossEarningsChart = _resolveComponent("GrossEarningsChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_WelcomeBack),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_TotalSalesChart)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_TotalOrdersChart)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_TotalProfitChart)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_TotalRevenueChart)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_RecentEarningsChart)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_SalesByLocations)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_TransactionHistory)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_RecentOrders)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_RealTimeSalesChart)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_SalesOverviewChart)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_GrossEarningsChart)
      ])
    ])
  ]))
}